import { useCallback } from "react";

import { GlobalAppEventEnum, Log, useGridExpandedCollapse } from "@ryde/shared";

import { useCompanyScopeContext } from "../contexts";

export const useGlobalEffectActions = () => {
  const { eventEmitter } = useCompanyScopeContext();
  const { collapseAll } = useGridExpandedCollapse();

  const collapseExpandedRowsAppEvent = useCallback(() => {
    collapseAll();
    Log.debug(`Toggle collapse rows called`);
  }, [collapseAll]);

  const resetPaginationAppEvent = useCallback(() => {
    eventEmitter?.emit(GlobalAppEventEnum.RESET_PAGINATION);
    Log.debug(`Reset pagination rows called`);
  }, [eventEmitter]);

  const startDragAppEvent = useCallback(() => {
    eventEmitter?.emit(GlobalAppEventEnum.START_DRAG);
    Log.debug(`Start drag app event called`);
  }, [eventEmitter]);

  return {
    collapseExpandedRowsAppEvent,
    resetPaginationAppEvent,
    startDragAppEvent,
  };
};
